(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define('react-join-form',["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactJoinLink"] = factory(require("react"));
	else
		root["ReactJoinLink"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utility = undefined;
	
	var _JoinLink = __webpack_require__(1);
	
	var _JoinLink2 = _interopRequireDefault(_JoinLink);
	
	var _utility = __webpack_require__(11);
	
	var _utility2 = _interopRequireDefault(_utility);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _JoinLink2.default;
	exports.utility = _utility2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatMeetingId = __webpack_require__(4);
	
	var _JoinFormular = __webpack_require__(5);
	
	var _JoinFormular2 = _interopRequireDefault(_JoinFormular);
	
	var _JoinText = __webpack_require__(9);
	
	var _JoinText2 = _interopRequireDefault(_JoinText);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	// $FlowFixMe: required module not found
	
	
	var JoinLink = function (_React$Component) {
	  _inherits(JoinLink, _React$Component);
	
	  function JoinLink(props) {
	    _classCallCheck(this, JoinLink);
	
	    var _this = _possibleConstructorReturn(this, (JoinLink.__proto__ || Object.getPrototypeOf(JoinLink)).call(this, props));
	
	    _this.state = {
	      isJoinMeeting: props.isJoinMeetingInitial ? props.isJoinMeetingInitial : true,
	      isJoinSelected: false,
	      joinMeetingId: ''
	    };
	    return _this;
	  }
	
	  _createClass(JoinLink, [{
	    key: 'toggleJoinMeetingShown',
	    value: function toggleJoinMeetingShown(event) {
	      this.setState(function (prevState) {
	        return {
	          isJoinMeeting: !prevState.isJoinMeeting,
	          isJoinSelected: true
	        };
	      });
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      var prefix = '';
	      var targetValue = (0, _formatMeetingId.formatId)((0, _formatMeetingId.cleanId)(event.currentTarget.value, prefix), prefix);
	      this.setState({ joinMeetingId: targetValue });
	    }
	  }, {
	    key: 'renderJoinText',
	    value: function renderJoinText() {
	      var _this2 = this;
	
	      if (this.state.isJoinMeeting) {
	        return _react2.default.createElement(_JoinText2.default, { onClick: function onClick(e) {
	            return _this2.toggleJoinMeetingShown(e);
	          }, joinLinkText: this.props.t('links.g2m.join') });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderJoinForm',
	    value: function renderJoinForm() {
	      var _this3 = this;
	
	      if (!this.state.isJoinMeeting) {
	        return _react2.default.createElement(_JoinFormular2.default, {
	          joinMeeting: this.props.onJoinClick,
	          onChange: function onChange(e) {
	            return _this3.handleInputChange(e);
	          },
	          inputValue: this.state.joinMeetingId,
	          validate: this.props.validate,
	          isSelected: this.state.isJoinSelected,
	          joinButtonText: this.props.t('meeting.join'),
	          placeholder: this.props.t('meeting.joinMeetingIdValidationMessage')
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'join-form ' }, this.renderJoinText(), this.renderJoinForm());
	    }
	  }]);
	
	  return JoinLink;
	}(_react2.default.Component);
	
	JoinLink.defaultProps = {
	  isJoinMeetingInitial: true
	};
	exports.default = JoinLink;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function cleanId(value, prefix) {
	    return (value || '')
	        .replace(/\s/g, '')
	        .replace(/\/+$/, '')
	        .replace(/^.*\//, '')
	        .replace((prefix || ''), '')
	        .replace((prefix || '')
	        .replace(/\/+$/, '')
	        .replace(/^.*\//, ''), '');
	}
	exports.cleanId = cleanId;
	function cleanMeetingId(value) {
	    var fragment = (value || '').replace(/-/g, '');
	    if (/^\d\d{0,8}$/.test(fragment)) {
	        return fragment;
	    }
	    return '';
	}
	exports.cleanMeetingId = cleanMeetingId;
	function predictIdType(value) {
	    if ((value || '').length === 0) {
	        return '';
	    }
	    else if (cleanMeetingId(value).length !== 0) {
	        return 'meeting';
	    }
	    else {
	        return 'room';
	    }
	}
	exports.predictIdType = predictIdType;
	function formatId(value, prefix) {
	    switch (predictIdType(value)) {
	        case 'meeting':
	            return value
	                .replace(/-/g, '')
	                .replace(/^(\d{3})(\d{3})(\d+)$/, '$1-$2-$3')
	                .replace(/^(\d{3})(\d+)$/, '$1-$2');
	        case 'room':
	            return prefix + value;
	        default:
	            return '';
	    }
	}
	exports.formatId = formatId;
	function formatPhoneNumber(phoneNumber) {
	    return phoneNumber.replace(/-/g, '')
	        .replace(/^(\d{3})(\d+)$/, '($1) $2')
	        .replace(/(\d{3})(\d+)/, '$1-$2');
	}
	exports.formatPhoneNumber = formatPhoneNumber;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _joinFormular = __webpack_require__(6);
	
	var _joinFormular2 = _interopRequireDefault(_joinFormular);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

	exports.default = _joinFormular2.default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JoinValidationMsg = __webpack_require__(7);
	
	var _JoinValidationMsg2 = _interopRequireDefault(_JoinValidationMsg);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var timeoutId = void 0;
	var currentSelection = { start: 0, end: 0 };
	var getSelection = function getSelection(el) {
	  var start = void 0;
	  var end = void 0;
	  var rangeEl = void 0;
	  var clone = void 0;
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	      rangeEl.moveToBookmark(window.getSelection().createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {
	      /* not focused or not visible */
	    }
	  }
	
	  return { start: start, end: end };
	};
	
	var setSelection = function setSelection(el, selection) {
	  var rangeEl = void 0;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(selection.start || 0, selection.end || 0);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', selection.start);
	      rangeEl.moveEnd('character', (selection.end || 0) - (selection.start || 0));
	      rangeEl.select();
	    }
	  } catch (e) {
	    /* not focused or not visible */
	  }
	};
	
	var JoinFormular = function (_React$Component) {
	  _inherits(JoinFormular, _React$Component);
	
	  function JoinFormular() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinFormular);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinFormular.__proto__ || Object.getPrototypeOf(JoinFormular)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      validateResult: false
	    }, _this.textInput = '', _this.onClickHandler = function () {
	      if (_this.props.validate(_this.props.inputValue)) {
	        _this.props.joinMeeting(_this.props.inputValue);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinFormular, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.inputValue !== nextProps.inputValue) {
	        this.isValid(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      // save Cursor Position
	      currentSelection = this.textInput ? getSelection(this.textInput) : { start: 0, end: 0 };
	      // If nextProps is lager than textInput, formatId has added a dash or the other way around
	      if (this.textInput && this.textInput.value !== nextProps.inputValue) {
	        var diff = nextProps.inputValue.length - this.textInput.value.length;
	        currentSelection.start += diff;
	        currentSelection.end += diff;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(previousProps) {
	      // restore Cursor Position
	      var validMeetingIdRegex = /^\d{0,3}-?\d{0,3}-?\d{0,3}$/;
	      if (this.textInput && this.textInput.value.match(validMeetingIdRegex)) setSelection(this.textInput, currentSelection);
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid(nextProps) {
	      var _this2 = this;
	
	      timeoutId = setTimeout(function () {
	        var validateResult = _this2.props.validate(nextProps.inputValue);
	        _this2.setState({ validateResult: validateResult });
	      }, 300);
	    }
	  }, {
	    key: 'renderValidationMsg',
	    value: function renderValidationMsg() {
	      var placeholder = '';
	      if (this.props.inputValue !== '' && !this.props.validate(this.props.inputValue)) {
	        placeholder = this.props.placeholder;
	        return _react2.default.createElement(_JoinValidationMsg2.default, { placeholder: placeholder });
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var className = this.state.validateResult ? '' : 'has-error';
	      return _react2.default.createElement('form', { className: 'input-group ' + className }, _react2.default.createElement('div', { className: 'join-formular-container' }, _react2.default.createElement('div', { className: 'join-inner-formular-container' }, _react2.default.createElement('input', {
	        ref: function ref(input) {
	          _this3.textInput = input;
	        },
	        type: 'text',
	        id: 'joinInput',
	        className: 'join-grey-input form-control',
	        placeholder: this.props.placeholder,
	        onChange: function onChange(event) {
	          _this3.props.onChange(event);
	          clearTimeout(timeoutId);
	        },
	        value: this.props.inputValue,
	        autoFocus: true
	      }), _react2.default.createElement('div', { className: 'input-group-btn' }, _react2.default.createElement('button', { id: 'joinBtn', className: 'btn btn-primary', type: 'submit', disabled: !this.state.validateResult, onClick: this.onClickHandler }, this.props.joinButtonText))), this.renderValidationMsg()));
	    }
	  }]);
	
	  return JoinFormular;
	}(_react2.default.Component);
	
	JoinFormular.defaultProps = {
	  joinButtonText: 'MISSING_TEXT_JOIN',
	  placeholder: 'MISSING_PLACEHOLDER_TEXT'
	};
	exports.default = JoinFormular;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _joinValidationMsg = __webpack_require__(8);
	
	var _joinValidationMsg2 = _interopRequireDefault(_joinValidationMsg);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

	exports.default = _joinValidationMsg2.default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var JoinValidationMsg = function (_React$Component) {
	  _inherits(JoinValidationMsg, _React$Component);
	
	  function JoinValidationMsg(props) {
	    _classCallCheck(this, JoinValidationMsg);
	
	    return _possibleConstructorReturn(this, (JoinValidationMsg.__proto__ || Object.getPrototypeOf(JoinValidationMsg)).call(this, props));
	  }
	
	  _createClass(JoinValidationMsg, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'join-validation-message-meetme' }, this.props.placeholder);
	    }
	  }]);
	
	  return JoinValidationMsg;
	}(_react2.default.Component);
	
	JoinValidationMsg.defaultProps = {
	  placeholder: 'MISSING_PLACEHOLDER_TEXT'
	};
	exports.default = JoinValidationMsg;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _joinText = __webpack_require__(10);
	
	var _joinText2 = _interopRequireDefault(_joinText);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

	exports.default = _joinText2.default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var JoinText = function (_React$Component) {
	  _inherits(JoinText, _React$Component);
	
	  function JoinText() {
	    _classCallCheck(this, JoinText);
	
	    return _possibleConstructorReturn(this, (JoinText.__proto__ || Object.getPrototypeOf(JoinText)).apply(this, arguments));
	  }
	
	  _createClass(JoinText, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('a', {
	        tabIndex: 0,
	        className: 'join-link-wrapper',
	        onClick: function onClick(event) {
	          _this2.props.onClick(event);
	        }
	      }, _react2.default.createElement('span', { className: 'join-link-text' }, this.props.joinLinkText));
	    }
	  }]);
	
	  return JoinText;
	}(_react2.default.Component);
	
	JoinText.defaultProps = {
	  joinLinkText: 'MISSING_TEXT_JOIN_LINK'
	};
	exports.default = JoinText;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {};

/***/ })
/******/ ])
});
;
//# sourceMappingURL=bundle.js.map;
